import React from "react";
import { Typography, Card, Row, Col } from "antd";
import { Layers3, Route } from "lucide-react";
import type { JobType } from "./types";

const { Title, Text } = Typography;

interface JobTypeOption {
  jobType: JobType;
  title: string;
  description: string;
  icon: React.ReactNode;
}

const JOB_TYPE_OPTIONS: JobTypeOption[] = [
  {
    jobType: "groundworks",
    title: "Groundworks",
    description: "Cut & Fill, Foundations, Drainage, Plot Drives, Paving, Walls, and more.",
    icon: <Layers3 size={28} color="#0891b2" />,
  },
  {
    jobType: "roadsAndSewers",
    title: "Roads & Sewers",
    description: "Preliminary Items, Foul Sewers, Storm Sewers, Roads, Main Services, and more.",
    icon: <Route size={28} color="#0891b2" />,
  },
];

interface JobTypeSelectionProps {
  onSelect: (jobType: JobType) => void;
}

const JobSelection: React.FC<JobTypeSelectionProps> = ({ onSelect }) => {
  return (
    <div style={{ padding: "24px" }}>
      <div style={{ marginBottom: 24 }}>
        <Title level={4} style={{ margin: 0 }}>
          Takeoff Configuration
        </Title>
        <Text style={{ color: "#6b7280" }}>
          Select the job type you'd like to configure the takeoff table fields for.
        </Text>
      </div>

      <Row gutter={[16, 16]}>
        {JOB_TYPE_OPTIONS.map((option) => (
          <Col xs={24} sm={12} md={8} key={option.jobType}>
            <Card
              hoverable
              onClick={() => onSelect(option.jobType)}
              style={{ height: "100%", borderRadius: 8 }}
              styles={{ body: { display: "flex", flexDirection: "column", gap: 12, padding: 20 } }}
            >
              {option.icon}
              <Title level={5} style={{ margin: 0 }}>
                {option.title}
              </Title>
              <Text style={{ color: "#6b7280", fontSize: 13 }}>{option.description}</Text>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default JobSelection;
